// import { UserDataT } from "@/types/auth";
import { create } from "zustand";
import { persist } from "zustand/middleware";

const useUserAuthStore = create()(
  persist(
    (set) => ({
      data: null,
      setUserData: (data) => {
        set((state) => ({ data: data }));
      },
      setLogout: () => {
        set((state) => ({ data: null }));
      },
    }),
    { name: "authUser" }
  )
);

export default useUserAuthStore;
